import { teamMembers } from '../mock';
import { Mail } from 'lucide-react';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">QUI SOMMES-NOUS</h1>
          <p className="page-subtitle">
            Une équipe passionnée au service des échanges culturels
          </p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="section-container">
        <div className="mission-content">
          <div className="mission-text">
            <h2 className="section-title">Notre Mission</h2>
            <p className="section-text">
              Créer des relations enrichissantes entre des familles françaises et des anglophones 
              en favorisant des échanges interculturels et une pratique quotidienne de l'anglais.
            </p>
            <p className="section-text">
              Nous permettons à des familles françaises locales de pratiquer l'anglais de manière régulière 
              en conversant avec un anglophone natif, tout en créant une dynamique autour de l'apprentissage 
              et des échanges interculturels.
            </p>
          </div>
          <div className="mission-image">
            <img 
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxsYW5ndWFnZSUyMGxlYXJuaW5nfGVufDB8fHx8MTc2ODIyMDQ0MHww&ixlib=rb-4.1.0&q=85"
              alt="Échanges culturels"
              className="rounded-image"
            />
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="section-container">
          <h2 className="section-title">Nos Valeurs</h2>
          <div className="values-grid">
            <div className="value-card">
              <h3>Bienveillance</h3>
              <p>Nous cultivons un environnement chaleureux et accueillant pour tous</p>
            </div>
            <div className="value-card">
              <h3>Qualité</h3>
              <p>Nous sélectionnons avec soin chaque anglophone pour garantir une expérience exceptionnelle</p>
            </div>
            <div className="value-card">
              <h3>Engagement</h3>
              <p>Nous assurons un suivi personnalisé tout au long du séjour</p>
            </div>
            <div className="value-card">
              <h3>Respect</h3>
              <p>Nous valorisons la diversité culturelle et les échanges mutuels</p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <div className="section-container">
          <h2 className="section-title">Équipe TEREKA</h2>
          <p className="section-text text-center mb-12">
            Des professionnels dévoués à l'éducation et aux échanges culturels
          </p>
          <div className="team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-card">
                <div className="team-image-container">
                  <img 
                    src={member.image} 
                    alt={member.name}
                    className="team-image"
                  />
                </div>
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <p className="team-bio">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Territory Section */}
      <section className="territory-section">
        <div className="section-container">
          <h2 className="section-title">Notre Territoire</h2>
          <div className="territory-content">
            <div className="territory-image">
              <img 
                src="https://images.unsplash.com/photo-1727193891594-4982814ed61f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxMaW9uJTIwZGUlMjBCZWxmb3J0fGVufDB8fHx8MTc2ODIyMDQxOXww&ixlib=rb-4.1.0&q=85"
                alt="Lion de Belfort"
                className="rounded-image"
              />
            </div>
            <div className="territory-text">
              <h3>Le Territoire de Belfort</h3>
              <p>
                Nous sommes fiers d'opérer dans le Territoire de Belfort, une région riche en histoire 
                et en culture. Le Lion de Belfort, symbole de résistance et de fierté, représente parfaitement 
                nos valeurs de courage et d'engagement.
              </p>
              <p>
                C'est dans ce cadre exceptionnel que nous proposons aux familles locales et des alentours 
                de vivre une expérience d'immersion anglophone unique.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="about-cta">
        <div className="about-cta-content">
          <Mail size={48} className="cta-icon" />
          <h2>Une question sur notre association ?</h2>
          <p>N'hésitez pas à nous contacter pour en savoir plus</p>
          <a href="/contact" className="cta-link">Contactez-nous</a>
        </div>
      </section>
    </div>
  );
};

export default About;